import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
import { useSelector } from 'react-redux';
import {useFloating, autoUpdate, autoPlacement, shift} from '@floating-ui/react';

const NavigationItem = ({ links = [], contentLink = null, level }) => {
  const useDrawer = useSelector((state) => state.navigation.useDrawer);

  const toggleMenu = (e) => {
    e.preventDefault();
    refs.floating.current.classList.toggle('navbar__menu--show');
  };
  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const selectedClass =
    contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
  const hasChildrenClass = links.length > 0 ? 'has-children' : null;
  const hasNameOrChildren = (link) =>
    link.name || (link.links || []).length > 0;

  const {refs, floatingStyles} = useFloating({
    whileElementsMounted: autoUpdate,
    middleware: [autoPlacement({
      allowedPlacements: ['bottom-start', 'bottom-end'],
    }),
    shift({
      padding: 0,
    })],
  });


  return (
    <Fragment>
      {!contentLink ? (
        <a
          className="navbar__link--block navbar__icon--menu navbar__icon"
          onClick={toggleMenu}
          rel="nofollow"
          href="#"
          title={translate('general.menu') || 'menu'}
        ></a>
      ) : (
        <Fragment>
          <a
            ref={refs.setReference}
            className={`navbar__link ${selectedClass} ${
              hasChildrenClass || ''
            } ${additionClass || ''}`}
            href={contentLink.url || '#'}
          >
            {contentLink.imageUrl && (
              <div className="navbar__img-container">
                <img
                  src={contentLink.imageUrl}
                  height="75"
                  width="75"
                  alt=""
                  className="navbar__list-item"
                />
              </div>
            )}

            <span
              dangerouslySetInnerHTML={{
                __html: contentLink.name,
              }}
            ></span>
          </a>
          {links.length > 0 && (
            <div
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            ></div>
          )}
        </Fragment>
      )}

      {links.length > 0 && (
        <div
          style={level === 2 && window.innerWidth > 1023  ? floatingStyles : null}
          className={`navbar__menu navbar__menu--level${String(level)} ${
            (!useDrawer && level === 2) || level === 1
              ? 'navbar__menu--anon'
              : ''
          }`}
          ref={refs.setFloating}
        >
          <div className="navbar__menu-header">
            {!contentLink ? (
              <span
                className="navbar__icon navbar__icon--close"
                onClick={toggleMenu}
              ></span>
            ) : (
              <Fragment>
                <i
                  className="navbar__icon--caret-left navbar__icon"
                  onClick={toggleMenu}
                ></i>
                <span
                  className="navbar__title"
                  onClick={toggleMenu}
                  dangerouslySetInnerHTML={{
                    __html: contentLink.name,
                  }}
                ></span>
              </Fragment>
            )}
          </div>
          <ul className="navbar__menu-links">
            {links.length > 0 &&
              links.map(
                (link, index) =>
                  hasNameOrChildren(link) && (
                    <li className="navbar__item" key={index}>
                      <NavigationItem
                        links={link.links}
                        contentLink={link}
                        level={level + 1}
                      />
                    </li>
                  )
              )}
          </ul>
        </div>
      )}
    </Fragment>
  );
};

export default NavigationItem;
